export const module = {
  herder: {
    title1: "首页",
    title2: "任务",
    title3: "兑换",
    title4: "活动",
    title5: "帮助",
  },
  navigation: {
    title1: "我的首页",
    title2: "任务记录",
    title3: "兑换历史",
    title4: "金币明细",
    title5: "账户设置",
    title6: "我的邀请",
    title7: "我的信用值",
  },
  notice: {
    title1: "通知",
    title2: "全部清除",
    title3: "设为已读",
    title4: "删除",
  },
  homepage: {
    title1: "等级",
    title2: "立即签到",
    title3: "距离下一等级还差",
    title4: "我的金币",
    title5: "我的信用值",
    title6: "奖励系数",
    title7: "查看明细",
    title8: "任务列表",
    title9: "查看更多",
    title10: "支持设备",
    title11: "金币",
    title12: "分钟",
    title13: "隐藏",
    title14: "多次参与",
    title15: "已领取",
    title16: "第",
    title17: "天",
    title18: "待领取",
    title19: "已连续签到",
    title20: "今日签到",
    title21: "天",
    signing: "签到中",
    signed: "已签到",
    noData: "暂无数据",
    multipleCompletion: "多次完成",
    participateNow: "立即参与",
    todaySigned: "今日已签到",
    sunday: "周日",
    monday: "周一",
    tuesday: "周二",
    wednesday: "周三",
    thursday: "周四",
    friday: "周五",
    saturday: "周六",
    fiveStarAlt: "五角星",
    placeholderText: "我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容",
    imageAlt: "图片"
  },
  taskRecord: {
    title1: "参与时间",
    title2: "开始日期",
    title3: "至",
    title4: "结束日期",
    title5: "参与状态",
    title6: "请选择",
    title7: "审核状态",
    title8: "筛选",
    title9: "问卷编号",
    title10: "问卷名称",
    title11: "参与时间",
    title12: "金币奖励",
    title13: "参与状态",
    title14: "审核状态",
    title15: "请输入问卷编号或名称",
  },
  redemptionHistory: {
    title1: "兑换历史",
    title2: "订单号",
    title3: "奖品名称",
    title4: "交易时间",
    title5: "消耗金币",
    title6: "订单状态",
    title7: "订单备注",
  },
  goldHistory: {
    title1: "金币余额",
    title2: "冻结金额",
    title3: "累计收入",
    title4: "累计支出",
    title5: "参与时间",
    title6: "开始日期",
    title7: "至",
    title8: "结束日期",
    title9: "审核状态",
    title10: "请选择",
    title11: "筛选",
    title12: "名称",
    title13: "时间",
    title14: "金币",
    title15: "金币明细",
    title16: "变动年份",
    title17: "选择年",
    title18: "变动类型",
    title19: "积分类型",
    title20: "触底加载更多",
    title21: "已经到底了~",
    title22: "暂无数据",
    title23: "变动时间",
    title24: "变动数量",
    title25: "描述",
    title26: "收入",
    title27: "支出",
    title28: "问卷状态",
  },
  account: {
    title1: "基本信息",
    title2: "资料完整度",
    title3: "完善信息可增加10信用值",
    title4: "个人信息",
    title5: "账号管理",
    title6: "姓名",
    title7: "性别",
    title8: "出生日期",
    title9: "省份",
    title10: "城市",
    title11: "区/县",
    title12: "职位",
    title13: "个人月薪",
    title14: "家庭月收入",
    title15: "私有车",
    title16: "是否有小孩",
    title17: "保存",
    title18: "修改昵称",
    title19: "一个月仅修改一次",
    title20: "修改",
    title21: "手机号",
    title22:
      "请输入您的常用手机号码，手机验证通过将不允许修改。如您已更换手机号码，请联系客服人员。",
    title23: "密码",
    title24: "定期修改密码有利于账号安全",
    title25: "微信",
    title26: "未绑定",
    title27: "去绑定",
    title28: "第三方绑定快捷登录",
    title29: "支付宝",
    title30: "已绑定",
    title31: "账户设置",
    title32: "请输入",
    title33: "请选择",
    title34: "婚姻状况",
    title35: "学历",
    title36: "工作状态",
    title37: "个人月收入",
    title38: "家庭月收入",
    title39: "职位",
    title40: "是否有小孩",
    title41: "最小小孩的性别",
    title42: "最小小孩出生年份",
    title43: "汽车品牌",
    title44: "汽车型号",
    title45: "常用汽车购买年份",
    title46: "个人患有疾病",
    title47: "家庭乘员患有疾病",
    title48: "支付宝账号",
    title49: "未绑定",
    title50: "绑定",
    title51: "支付宝账号绑定, 首次提交后即确认，不允许修改",
    title52: "手机验证主要是为了在兑换过程中实名认证，以保护您的账号安全。",
    title53: "请输入您的常用手机号码，手机验证通过将不允许修改。如您已更换手机号码，请联系客服人员。",
    title54: "修改头像",
    title55: "修改密码",
    title56: "原密码",
    title57: "新密码",
    title58: "确认密码",
    title59: "取消",
    title60: "确认",
    title61: "仅首次可修改",
    title62: "第三方账号绑定",
    title63: "男",
    title64: "女",
    title65: "是",
    title66: "否",
    title67: "出生日期",
    title68: "请输入",
  },
  invite: {
    title1: "好友邀请",
    title2: "方式一：分享链接",
    title3: "复制链接给朋友，朋友通过此链接注册成为会员，即成功邀请好友",
    title4: "一键复制",
    title5: "方式二：下载二维码",
    title6: "点击下载",
    title7: "我的邀请",
    title8: "人",
    title9: "已邀请",
    title10: "元",
    title11: "已获得",
    title12: "请输入好友账号",
    title13: "好友账号",
    title14: "注册时间",
    title15: "为我赚得",
    title16: "废卷率",
    title17: "活动规则",
    title18: "1.通过推广链接、二维码、微信微博方式邀请朋友注册爱答卷。",
    title19:
      "2.您推荐的好友完成任意调查可获得10%的提成。例如：您推荐好友A注册“爱答卷”，“A”第一次完成20元的调查，2元的提成奖励。",
    title20:
      "3.如果您的好友超过6个月没有参与任何问卷，为避免资源闲置，账户将会视为休眠用户，并与您断开好友关系，您也无法获得奖励。",
    title21:
      "4.活动日期：2023-1-1至2023-12-31.注意：活动期间内奖励翻倍，活动结束后奖励恢复正常。",
  },
  credit: {
    title1: "等级",
    title2: "了解升级规则",
    title3: "距离下一等级还差",
    title4: "信用值",
    title5: "信用值详情",
    title6: "收益提升",
    title7: "当前等级权益",
    title8: "信用值累计规则",
    title9: "1.一般:≤60时,为V1会员,可拥有30天保护卡;",
    title10:
      "2.中等:61≤信用值≤100,为V2会员,可拥有额外奖励卡5%、1张金盾保护卡; ",
    title11:
      "3.良好:101≤信用值≤200,为V3会员,可拥有额外奖励卡10%、1张金盾保护卡、VIP快速审核通道; ",
    title12:
      "4.优秀:201≤信用值≤500,为V4会员,可拥有额外奖励卡15%、1张金盾保护卡、VIP快速审核通道; ",
    title13:
      "5.钻石:501≤信用值≤800,为V5会员,可拥有额外奖励卡20%、1张金盾保护卡、VIP快速审核通道; ",
    title14:
      "6.王者:801≤信用值≤1000,为V6会员,可拥有额外奖励卡40%、1张金盾保护卡、VIP快速审核通道; ",
    title15: "备注",
    title16: "1.连续6个月内未参与任何问卷,信用值将会清零。",
    title17:
      "2.翻倍奖励卡奖励发放规则,每月5日系统会根据您当前的信用值计算出翻倍卡数量,对您上月完成且审核通过的项目随机进行翻倍。特别说明:假设当前信用值大于801,获得4张翻倍卡,但上个月只完成且审核通过2个商业问卷,那么只能翻倍2个商业问卷奖励,剩余的2个翻倍卡失效。活动日期(2023年5月1日至2023年9月30日) ",
    title18:
      "3.金盾保护卡用途,信用值大于60初始值后,对于答卷审核不通过的问卷不再扣除金币。",
    title19:
      "4.VIP快速审核通道卡只针对兑换微信红包订单,支付宝订单保持每周五统一审核发放订单。",
    title20: "5.信用值体系会根据实际情况进行调整。",
    title21:
      "6.福利卡包含“翻倍卡”、“増值卡”、“保护卡” 、“审核卡”、“抽奖卡”。具体发放的卡劵及对应数量,与当时信用值有关,以实际发放时为准。",
    title22: "7.通过非正当手段获取信用值者,将受到惩罚,严重者将被删除账号。",
    title23:
      "8.目前只针对商业调查进行信用值审核,K问卷,Y问卷,小幸运问卷,G问卷,S问卷除外。 ",
    title24:
      "9.信用值低于初始值60以后,支付宝和微信兑换订单将进入人工答卷内容审核阶段,审核答卷完成后进行订单审核,一般时间1-4周时间范围。",
    title25: "带您了解更多问卷小tips，解锁更多等级权益",
    title26: "当前等级分",
    title27: "距离",
    title28: "等级",
    title29: "还差",
    title30: "信用值",
    title31: "等级v6",
    title32: "30天保护卡",
    title33: "首次完成注册",
    title34: "额外奖励3%",
    title35: "额外奖励10%",
    title36: "额外奖励15%",
    title37: "额外奖励20%",
    title38: "额外奖励40%",
    title39: "完成任务",
    title40: "金盾保护卡",
    title41: "VIP快速审核通道",
    title42: "铁牌",
    title43: "铜牌",
    title44: "银牌",
    title45: "金牌",
    title46: "钻石",
    title47: "王者",
    title48: "会员",
    title49: "一般",
    title50: "中等",
    title51: "良好",
    title52: "优秀",
    title53: "增加",
    title54: "扣除",
    title55: "触底加载更多",
    title56: "已经到底了~",
    title57: "暂无数据",
    title58: "信用值历史",
    title59: "返回到上一级",
    title60: "发生时间",
    title61: "信用值",
    title62: "状态",
    title63: "信用描述",
    title64: "已完成",
    title65: "未完成",
    title66: "其它",
    title67: "已审核",
    title68: "待审核",
  },
  exchange: {
    title1: "兑换",
    title2: "现金类",
    title3: "卡券类",
    title4: "礼品类",
    title5: "金币",
    title6: "剩余",
    title7: "个",
    title8: "立即兑换",
    title9: "可使用金币兑换现金",
    title10: "暂无数据",
    title11: "10元代金券",
    title12: "10元话费卡",
    title13: "提示",
    title14: "请确认您的支付宝账号和姓名:",
    title15: "支付宝账号:",
    title16: "支付宝账号:未填写",
    title17: "姓名:",
    title18: "未填写",
    title19: "取消",
    title20: "更新支付宝",
    title21: "我已确认兑换账号，立即兑换",
    title22: "此奖品库存不足啦，请耐心等待管理员补货哦！",
    title23: "兑换成功",
  },
  activity: {
    title1: "热门活动",
    title2: "任务奖励",
    title3: "金币",
    title4: "立即参与",
    title5: "往期活动",
  },
  commerce: {
    title1: "商务合作",
    title2: "如有需要，请致电联系我们",
    title3: "欢迎以下合作方式",
    title4: "联系方式",
    title5: "市场调研",
    title6: "内容合作 流量分发",
    title7: "会员招募",
  },
  taskD: {
    title1: "日常任务",
    title2: "问卷名称",
    title3: "仅电脑端答题",
    title4: "金币数量",
    title5: "金币",
    title6: "奖励方式",
    title7: "实时奖励",
    title8: "问卷时长",
    title9: "约",
    title10: "分钟",
    title11: "问卷要求",
    title12:
      " 1.请务必认真仔细答题，保持答题的合理性，不得出现线性答题情况否则将会被作废，影响信用值，谢谢配合;<br/>2.后期检查将会剔除不合格的数据，同时扣除信用值;<br/>3.如有重复雷同数据，将作封号处理，感谢您的参与！",
    title13: "开始答卷",
    title14: "贴心小提示",
    title15:'1.在回答问卷过程中，请不要中断，避免失去获 得金币的机会。<br/>2。答题过程中请不要点击返回按钮。<br/>3.部分问卷在国外而导致问卷加载缓慢时，请耐 心等待。',
    title16:'通过率'
  },
};
